<template>
  <div>
    <div style="margin-top: -3px; width: 100%; display: flex; justify-content: space-between;">
      <div class="mobil-disebled">
        <b-button class="navbarBtnTashxis" @click="AddRetsept" variant="primary">
          <b-icon icon="plus-circle-fill"></b-icon>
        </b-button>
      </div>
    </div>
    <!-- {{ registration_drug }} -->
    <div v-for="(itemR, indR) in registration_drug" :key="indR">
      <div class="mobil-disebled">
        <button v-b-modal="`modal-palataa` + modalId + indR" class="navbarBtn mt-3">
          {{ $t("Reagntlar biriktirish ") }}
        </button>
        <b-modal :id="'modal-palataa' + modalId + indR" size="xl" :title="$t('Reagntlar biriktirish ')" hide-footer>
          <div>
            <table class="table table-sm table-bordered">
              <thead class="BayonotTheadr">
                <tr>
                  <th style="width: 30px;">
                    <!-- :disabled="localUser.doctor_id != doctor_id" -->
                    <b-button variant="success" @click="Add()" class="retsept-add-btn"><span> <b-icon icon="plus"
                          color="#fff"></b-icon> </span></b-button>
                  </th>
                  <th>{{ $t("Дори") }}</th>
                  <th>{{ $t("Кун") }}</th>
                  <th>{{ $t("Кун") }}</th>
                  <th>{{ $t("Кетиш вақт") }}</th>
                  <th>{{ $t("Soni") }}</th>
                  <th>{{ $t("Маҳал") }}</th>
                  <th>{{ $t("Қўшимчалар") }}</th>
                  <th style="width: 40px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in retsep" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td style="width: 300px;">
                    <div class="select-btn-add">
                      <v-select :options="reagent" ref="doriselect" :reduce="options => options.id"
                        v-model="item.reagent_id" label="name">
                      </v-select>
                    </div>
                  </td>
                  <td>
                    <div style="width: 100%">
                      <date-picker v-model="item.day_start" style="width: 100%;" format="DD.MM.YYYY" value-type="X"
                        type="datetime" :lang="lang"></date-picker>
                    </div>
                  </td>
                  <td>
                    <div style="width: 100%">
                      <vue-numeric v-model="item.day" class="numberic-style" @input="qoladiganKun"
                        separator="space"></vue-numeric>
                    </div>
                  </td>
                  <td>
                    <div style="width: 100%">
                      <date-picker disabled style="width: 100%" v-model="item.day_end" format="DD.MM.YYYY" value-type="X"
                        type="datetime" :lang="lang"></date-picker>
                    </div>
                  </td>
                  <td>
                    <div style="width: 100%">
                      <vue-numeric v-model="item.count" class="numberic-style" separator="space"></vue-numeric>
                    </div>
                  </td>
                  <td>
                    <b-input type="number" style="background: #fff; border: 1px solid #ced4da;"
                      v-model="item.maxal"></b-input>
                  </td>
                  <td>
                    <b-input id="textarea" style="background: #fff; border: 1px solid #ced4da;"
                      v-model="item.comment"></b-input>
                  </td>
                  <td>
                    <b-button style="width: 35px; height: 35px; display: flex; justify-content: center;"
                      variant="outline-danger" @click="deleteRetsep(index)">
                      <b-icon style="width: 17px;" icon="trash"></b-icon>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-button @click="RowClickedPalata(indR)">RowClickedPalata</b-button>
        </b-modal>
      </div>
      <table class="table table-sm table-bordered" style="background: #fff;">
        <thead class="shifokorTable">
          <tr>
            <th v-for="(item, index) of itemR.days" :key="index" style="height: 100px; width: 10px;" class="mobil-disebled">
              <div class="container">
                <p class="day-style">{{ item }}</p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="mobile-grids">
           
            <td class="mobile-grid" v-for="itemD in itemR.days">
              <table>
                
              {{ itemD }}
                <tr>
                  <th>
                    Nomi
                  </th>
                  <th>
                    Soni
                  </th>
                  <!-- <th>
                    Comment
                  </th> -->
                  <th>
                    Status
                  </th>
                </tr>
                <tr v-for="it in itemR.registration_drug_child">
                  <td v-if="itemD == it.day">
                    {{ reagent.find((val) => val.id == it.dori_id) ? reagent.find((val) => val.id == it.dori_id).name :
                      null }}
                  </td>
                  <td v-if="itemD == it.day">
                    {{ it.count }}
                  </td>
                  <!-- <td v-if="itemD == it.day">
                    {{ it.comment }}
                  </td> -->
                  <td v-if="itemD == it.day">
                    <b-icon icon="check-lg" @click="it.status = true" v-if="it.status != true"></b-icon>
                    <b-icon icon="check-all" v-if="it.status == true"></b-icon>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
export default {
  props: ["registration_drug", "hospital_summa", "backlog", "modalId", "modalIdCom"],
  components: {
    DatePicker
  },
  data() {
    return {
      reagent: [],
      // registration_drug:[],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        },
        monthBeforeYear: false
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      price: 0,
      comment: "",
      DayTable: [],
      User: [],
      retsep: [],
      itemsPalata: []
    };
  },
  filters: {
    dateFormatDD: function (date) {
      if (date != null) {
        return moment.unix(date).format("DD.MM.YYYY HH:mm");
      } else {
        return "";
      }
    }
  },
  methods: {
    AddRetsept() {
      let localUser = JSON.parse(localStorage.getItem('user'));
      this.registration_drug.push({
        user_id: localUser.id,
        registration_drug_child: [],
        days: [],
      })

      // const currentDate = new Date();

      // const day = currentDate.getDate().toString().padStart(2, '0');
      // const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-based
      // const year = currentDate.getFullYear().toString();
      // const formattedDate = `${year}-${month}-${day}`;
      // this.registration_drug.push({
      //   begin_day: formattedDate,
      //   user_id: 0,
      //   day: formattedDate,
      //   dori_table: []
      // })
    },
    AddDay() {
      
    },
    Add() {
      this.retsep.push({
        reagent_id: null,
        day_start: moment(new Date()).format("X"),
        day: null,
        day_end: moment(new Date()).format("X"),
        maxal: 0,
        count: null,
        comment: "",
      });
    },
    RowClickedPalata(index) {
      let self = this;
      let temp = self.registration_drug[index];
      for (const item of self.retsep) {
        let start = parseInt(item.day_start);
        for (let i = 0; i < item.day; i++) {
          var date1 = new Date(parseInt(start) * 1000).toLocaleDateString();
          var splitted = date1.split('.');
          date1 = splitted[2] + '-' + splitted[1] + '-' + splitted[0]
          for (let j = 0; j < item.maxal; j++) {
            if (!temp.days.includes(date1)) {
              temp.days.push(date1)
            }
            temp.registration_drug_child.push({
              dori_id: item.reagent_id,
              day: date1,
              comment: item.comment,
              status: false,
              count: item.count
            })
          }
          start += 86400;
        }
      }

      this.$bvModal.hide('modal-palataa' + this.modalId + index)
      this.retsep = []
    },
    qoladiganKun() {
      for (let index = 0; index < this.retsep.length; index++) {
        const element = this.retsep[index];
        // console.log(element.day,element.day_start,element.day_end)
        if (element.day !== " ") {
          let secondDay = moment
            .unix(parseInt(element.day_start))
            .add(element.day - 1, "registration_drug_days");
          element.day_end = moment(secondDay).format("X");
        }
      }
    },
    deletePalata(id, item) {
      let x = item.total_price;
      this.$emit("palataChange", x, false);
      this.vaqt = 0;
      this.registration_palata.splice(id, 1);
    },
    VazvratPalata(item, index) {
      this.$emit("palataChange", item.total_price, item.vazvrat, "vazvrat");
    },
    Reagent() {
      
      let self = this;
      axios({
        method: "get",
        url: "/prixod-dori/tovar"
      }).then(res => {
        if (res) {
          self.reagent = res.data.data;
        }
      });
    },
  },
  mounted() {
    this.Reagent();
    this.AddDay()
  }
};
</script>
<style>
.container {
  width: 10px;
  display: flex;
  align-items: center;
  /* Matinni vertikal tarzda joylash */
}

.day-style {
  transform: rotate(270deg);
  /* Matinni 90 gradusga aylantirish */
  transform-origin: left bottom;
  /* Aylantirish markazini belgilash */
  white-space: nowrap;
  /* Qator o'tkazmasini sozlash */
  margin: 0;
}

.palata-summ {
  height: 35px;
  width: 100%;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  border-radius: 5px;
  justify-content: center;
}

/* .custom-modal .modal-dialog .modal-content {
  width: 900px !important; 
} */
.navbarBtn-palata {
  padding: 0px 7px !important;
}

.palata-select .vs__selected-options span:first-child {
  width: 80% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.palata-select .vs__selected-options {
  width: 80%;
}

.palata-select {
  height: 30px;
}

.palata-select .vs__dropdown-toggle {
  height: 30px;
}

.palata-category {
  border: 1px solid rgb(46, 165, 255);

  background: #f0f0f03d;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.3);
  border-radius: 10px;
  padding: 10px 5px;
  margin: 10px 5px;
}

.palata-xona {
  border: 1px solid #0b0bdd;
  background: #fff;
  width: 245px;
  margin: 10px 5px;
  border-radius: 7px;
  padding: 7px 7px;
}

.palata-palata {
  display: flex;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 7px;
  background: #f0f0f03d;
  margin: 5px;
  padding: 5px 7px;
}

.palata-name {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #3f51b5;
}

.p-x-name {
  font-size: 17px;
  font-weight: 600;
  display: flex;
  /* border: 1px solid red; */
  /* margin: 5px 5px; */
  margin-top: 5px;
  justify-content: center;
  padding: 3px 5px;
}

.palataStatus {
  background: #ff00004a !important;
}

.numberic-style {
  height: 35px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.modalQidiruvp {
  width: 50%;
  float: right;
  /* position: relative; */
  /* left: 50%; */
}

.navbarBtn {
  color: #fff;
  border: 1px solid #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 5px 10px;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.3);
  background: #00009d;
  border-radius: 8px;
}
.mobile{
  display: none;
}
@media screen and (max-width: 600px) {
  .mobil-disebled {
    display: none;
  }
  .mobile-grids{
    display: grid;
    grid-template-columns: repeat(1,1fr);
  }
  .mobile-grid{
    display: grid;
    grid-template-columns: repeat(1,1fr);
  }
}
</style>
